import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { queryClient } from "./lib/queryClient";
import { AppUpdateBanner, reloadOnStaleChunk } from "./lib/appUpdate";

reloadOnStaleChunk();

// Matches Vite's own `base` (see vite.config.ts / VITE_BASE) so every
// <Link>/<Navigate> stays correct under a path-prefixed deployment (e.g.
// https://aqeel.myqnapcloud.com/ar/...) without every route needing to
// know about the prefix itself.
const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <AuthProvider>
          <App />
          <AppUpdateBanner />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
